var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-tooltip',{attrs:{"label":"View Available Integrations","position":"is-bottom"}},[_c('b-button',{attrs:{"label":"Setup instructions","type":"is-primary","size":"is-medium","icon-pack":"fas","icon-right":"arrow-right","outlined":""},on:{"click":_vm.showIntegrationsModal}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }